import React from 'react'
import ProductList from './ProductList'
import ProductDetail from './ProductDetail'
import Statics from '../static/Statics'

const Products = ({match}) => {
	const {slug} = match.params;

	if(slug){
		return (
			<ProductDetail slug={slug} />
		)
	}else{
		return (
			<Statics />
		)
	}
}

export default Products
